import { render, staticRenderFns } from "./famousRead.vue?vue&type=template&id=245d5afb&scoped=true&"
import script from "./famousRead.vue?vue&type=script&lang=js&"
export * from "./famousRead.vue?vue&type=script&lang=js&"
import style0 from "./famousRead.vue?vue&type=style&index=0&id=245d5afb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d5afb",
  null
  
)

export default component.exports